export default "__VITE_ASSET__BDIzHd2s__"